"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAtom = exports.useRxOrThrow = exports.useRx = exports.getImmediateOrThrow = exports.getImmediate = void 0;
const react_1 = require("react");
const operators_1 = require("rxjs/operators");
const wrapped_1 = require("@rixio/wrapped");
const use_subscription_1 = require("./use-subscription");
function getImmediate(observable) {
    let immediate = { status: "pending" };
    observable.pipe(operators_1.first()).subscribe(value => {
        immediate = { status: "fulfilled", value };
    }, error => {
        immediate = { status: "rejected", error };
    });
    return immediate;
}
exports.getImmediate = getImmediate;
function getImmediateOrThrow(observable) {
    const immediate = getImmediate(observable);
    if (immediate.status === "rejected") {
        throw immediate.error;
    }
    if (immediate.status !== "fulfilled") {
        throw new Error("Observable doesn't immediately emits value");
    }
    return immediate.value;
}
exports.getImmediateOrThrow = getImmediateOrThrow;
function useRx(observable, deps = [observable]) {
    const [, setCount] = react_1.useState(0);
    const wrapped = react_1.useMemo(() => wrapped_1.wrap(observable), [observable]);
    const value = react_1.useRef(wrapped_1.pendingWrapped);
    const initial = react_1.useRef(true);
    const sub = react_1.useMemo(() => wrapped.subscribe(next => {
        const current = value.current;
        value.current = next;
        if (!initial.current) {
            if (current.status !== next.status ||
                (current.status === "fulfilled" && next.status === "fulfilled" && current.value !== next.value)) {
                setCount(c => c + 1);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), deps);
    react_1.useEffect(() => {
        return () => sub.unsubscribe();
    }, [sub]);
    initial.current = false;
    return value.current;
}
exports.useRx = useRx;
function useRxOrThrow(observable) {
    return wrapped_1.toPlainOrThrow(useRx(observable));
}
exports.useRxOrThrow = useRxOrThrow;
function useAtom(atom) {
    const [state, setState] = react_1.useState(() => atom.get());
    use_subscription_1.useSubscription(atom, setState);
    return state;
}
exports.useAtom = useAtom;
